/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Roles_2Inputs */

const da_privacy_roles_2 = /** @type {(inputs: Privacy_Roles_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For **elevernes besvarelser, point og karakterer** er skolen (eller læreren) dataansvarlig, og vi er databehandler. Skoler, der bruger AImforA med elevdata, indgår en databehandleraftale med os. Skriv til os, så sender vi den.`)
};

/** @type {(inputs: Privacy_Roles_2Inputs) => LocalizedString} */
const en_privacy_roles_2 = da_privacy_roles_2;

/**

* @param {Privacy_Roles_2Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_roles_2 = /** @type {((inputs?: Privacy_Roles_2Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Roles_2Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_roles_2(inputs)
	return /** @type {LocalizedString} */ ("For **elevernes besvarelser, point og karakterer** er skolen (eller læreren) dataansvarlig, og vi er databehandler. Skoler, der bruger AImforA med elevdata, indgår en databehandleraftale med os. Skriv til os, så sender vi den.")
});